const Preferences = () => {
    const ID = "osper-nightwatch"
    const model = JSON.parse(localStorage.getItem(ID)  || "{}")
    const sanitizeKey = (k) => {
        return k.replaceAll(/\W/g,'_')
    }
    const get = (name) => {
        const key = sanitizeKey(name)
        if(model.hasOwnProperty(key)) return model[key]
    }
    const put = (name, val) => {
        const key = sanitizeKey(name)
        model[key] = val
        localStorage.setItem(ID, JSON.stringify(model))
    }

    return {
        get : get,
        put : put
    }
}

export default Preferences